window.pre_order_status = true;
document.addEventListener('DOMContentLoaded', () => {
  window.subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    // console.log("variant change",event)
    const variant = event.data?.variant;
    const sectionId = event.data?.sectionId;
    if (variant && variant.available == true) {
      const pd_url = 'https://preorders-api.elitesupps.com.au/get_availability?variant_id=' + variant.id;
      fetch(pd_url).then(res => res.json()).then(response => {
        if (response.code == 4) {
          const availEl = document.querySelector('.product__availability');
          if (availEl) availEl.innerHTML = "Availability online: <span class='in__stock'>PRE ORDER</span>";

          document.querySelectorAll('.preorder-delivery-info').forEach(el => {
            el.innerHTML = response.data.delivery_date;
          });

          const preorderInputs = `
            <input type='hidden' class="preorder-properties" name='properties[Pre order]' value="${response.data.delivery_date}">
            <input type='hidden' class="preorder-properties" name='properties[_is_preorder]' value="yes">
            <input type='hidden' class="preorder-properties" name='properties[_waitlist_id]' value="${response.data.waitlist_id}">`;

          const form = document.getElementById(`product-form-${sectionId}`);
          if (form) form.insertAdjacentHTML('beforeend', preorderInputs);

          const quickAddForm = document.getElementById(`product-form-quickadd-${sectionId}`);
          if (quickAddForm) quickAddForm.insertAdjacentHTML('beforeend', preorderInputs);

          document.querySelectorAll('.expected-delivery').forEach(el => { el.style.display = 'none'; });

          const productForm = document.getElementById(`ProductSubmitButton-${sectionId}`) || document.getElementById(`ProductSubmitButton-quickadd-${sectionId}`);
          if (productForm) {
            const addButtonText = productForm.querySelector('[name="add"] > span');
            if (addButtonText) addButtonText.textContent = 'PRE-ORDER';
          }
          // if(addButton.hasAttribute('disabled')) addButton.removeAttribute('disabled');

          document.querySelectorAll('[data-sis-widget-description]').forEach(el => el.classList.add('hidden'));

        } else {
          document.querySelectorAll('[data-sis-widget-description]').forEach(el => el.classList.remove('hidden'));
          document.querySelectorAll('.preorder-delivery-info').forEach(el => { el.innerHTML = ''; });
          document.querySelectorAll('.preorder-properties').forEach(el => el.remove());
          document.querySelectorAll('.expected-delivery').forEach(el => { el.style.display = ''; });
        }
      });
    }
  });

  if (window.check_pre_order_item == true) {
    fetch('/cart.js').then(res => res.json()).then(async (cart) => {
      const calls = cart.items.map(async (item) => {
        const pd_url = `https://preorders-api.elitesupps.com.au/get_availability?variant_id=${item.variant_id}`;
        const res = await fetch(pd_url);
        const response = await res.json();
        if (response.code != 4 && item.properties && item.properties['_is_preorder'] == 'yes') {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: item.key, quantity: item.quantity, properties: { '_': '' } })
          });
        }
        if (response.code == 4 && (!item.properties || !item.properties['_is_preorder'])) {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: item.key,
              quantity: item.quantity,
              properties: {
                'Pre order': response.data.delivery_date,
                '_is_preorder': 'yes',
                '_waitlist_id': response.data.waitlist_id
              }
            })
          });
        }
      });
      await Promise.all(calls);
      fetch('/?section_id=cart-drawer', { credentials: 'same-origin', method: 'GET' }).then(data => {
        data.text().then(html => {
          const cartItems = document.getElementById('CartDrawer-CartItems');
          if (cartItems) {
            cartItems.innerHTML = new DOMParser().parseFromString(html, 'text/html').querySelector('#CartDrawer-CartItems').innerHTML;
          }
        });
      });
    });
  }

  if (window.pre_order_list && window.pre_order_list.includes(parseInt(window.selected_variant))) {
    const variantSelects = document.querySelector('variant-radios');
    const variantInput = variantSelects?.querySelector('input[type="radio"]');
    if (variantInput) {
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
});
